<div class="update-address-dialog-content">
  <h4 class="modal-header">
    Edit Address
    <span class="close-icon-dialog"><mat-icon (click)="cancel()">close</mat-icon></span>
  </h4>
  @if (groupInfo$ | async; as groupInfo) {
  }
  <form [formGroup]="updateAddressFormGroup" class="update-address">
    <div class="form-wrapper">
      <div class="mat-row">
        <div class="mat-6 pad-r-2">
          <mat-label>Address Line 1<span class="asterisk-mark">*</span></mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-input">
            <input matInput placeholder="Enter Address Line 1" formControlName="addressLine1" />
          </mat-form-field>
          <app-custom-mat-hint [formGroup]="updateAddressFormGroup" controlName="addressLine1"></app-custom-mat-hint>
        </div>
        <div class="mat-6">
          <mat-label>Zip Code<span class="asterisk-mark">*</span></mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-input">
            <input (keydown)="numericOnly($event)" type="text" matInput placeholder="Enter Zip Code"
              formControlName="zipCode" />
          </mat-form-field>
          <app-custom-mat-hint [formGroup]="updateAddressFormGroup" controlName="zipCode"></app-custom-mat-hint>
        </div>
      </div>
      <div class="mat-row">
        <div class="mat-8 pad-r-2">
          <mat-label>Address Line 2<span class="asterisk-mark"></span></mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-input">
            <input matInput placeholder="Enter Address Line 2" formControlName="addressLine2" />
          </mat-form-field>
          <app-custom-mat-hint [formGroup]="updateAddressFormGroup" controlName="addressLine2"></app-custom-mat-hint>
        </div>
        <div class="mat-6 pad-r-2">
          <mat-label>State<span class="asterisk-mark">*</span></mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-select">
            <mat-select placeholder="Select State" formControlName="state" panelClass="custom-select-panel"
              [disableOptionCentering]="true" matNativeControl>
              <mat-option>
                <ngx-mat-select-search [formControl]="stateFilterControl" [clearSearchInput]="true"
                  [showToggleAllCheckbox]="false" placeholderLabel="Search state by Name..."
                  noItemsLabel="No states found">
                </ngx-mat-select-search>
              </mat-option>
              @if ((filteredStates | async)?.length === 0) {
                <mat-option disabled>
                  No states found
                </mat-option>
              }
              @if (filteredStates | async; as States) {
                <mat-option class="grp-dropdown" *ngFor="let state of filteredStates| async as States"
                  [value]="state.value">
                  {{state.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <app-custom-mat-hint [formGroup]="updateAddressFormGroup" controlName="state"></app-custom-mat-hint>
        </div>
        <div class="mat-6">
          <mat-label>City<span class="asterisk-mark">*</span></mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-input">
            <input matInput placeholder="Enter City" formControlName="city" />
          </mat-form-field>
          <app-custom-mat-hint [formGroup]="updateAddressFormGroup" controlName="city"></app-custom-mat-hint>
        </div>
      </div>
      @if (dialogData?.memberDetails?.relationshipCode === cardHolderRC && dependents$ | async; as dependentsData) {
        @if (dependentsData.length) {
          <div class="mat-row dependents-drop">
            <div class="mat-12">
              <mat-label>Select dependents</mat-label>
              <mat-form-field floatLabel="never" class="full-width mat-custom-select">
                <mat-select placeholder="Select" formControlName="dependents" multiple>
                  @for (value of dependentsData; track value) {
                    <mat-option [value]="{ patientId: value.patientId, personCode: value.personCode }">
                      {{ value.firstName }} {{ value.lastName }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <app-custom-mat-hint [formGroup]="updateAddressFormGroup" controlName="dependents"></app-custom-mat-hint>
            </div>
          </div>
        }
      }
    </div>
    <div class="mat-row dialog-btn-row">
      <div class="mat-12" fxLayoutAlign="end end">
        <button mat-button class="primary-btn" [disabled]="!checkIfAnythingUpdated() || updateAddressFormGroup.invalid || isSaving"
          (click)="save()">
          Save Changes
        </button>
        <button mat-button class="secondary-btn" (click)="cancel()">
          Cancel
        </button>
      </div>
    </div>
  </form>
</div>